module.exports = __webpack_public_path__ + "static/media/icon_credit_card.ea3a5711.png";